<script>
  import { getNotificationsContext } from "svelte-notifications";
  import { onMount } from "svelte";
  import AuthService from "../authService.js";
  import { navigateTo } from "svelte-router-spa";
  export let params;
  export let currentRoute;

  const { addNotification } = getNotificationsContext();

  let email = "";
  let error = null;
  let message = null;
  let button_text_send = 'Enviar'

  onMount(async () => {
    if (AuthService.isAuthenticated()) {
      navigateTo("/");
    }
  });

  async function recovery()
  {
    error = null;
    message = null;

    button_text_send = 'Enviando...'

    const response = await AuthService.recovery(email);

    if (!response.success)
    {
      if (response.body.code === 4)
      {
        error = response.body.details;
      }
      button_text_send = 'Enviar'
    }
    else
    {
      button_text_send = 'Enviar'

      addNotification({
        id: new Date().getTime(),
        text: "ATENCION:",
        description: "Se ha enviado las instrucciones para el cambio de contraseña al correo ingresado.",
        removeAfter: 10000,
        position: "bottom-right",
        type: "success"
      });

      navigateTo("/");

    }
  }
</script>

<style>
  .centered {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .notifications {
    z-index: 1!important;
  }
</style>

<section id="home">
  <div class="hero-wrap">
    <div class="hero-mask opacity-6 bg-dark" />
    <div
      class="hero-bg parallax"
      style="background-image:url('images/bg/image-11.jpg');" />
    <div class="hero-content d-flex flex-column fullscreen">
      <div class="centered bg-white px-4 py-4">
        <div />
        <div class="row">
          <div class="col py-4 px-4">
            <center>
              <h3 class="pb-3">Recuperación de Contraseña:</h3>
            </center>
            {#if message}
              <div class="alert alert-danger">{message}</div>
            {/if}
            <div class="form-group row">
              <div class="col-sm-12">
                <input
                  type="email"
                  id="inputEmail3"
                  bind:value={email}
                  class={`form-control inputs ${error && error.email ? 'is-invalid' : ''}`}
                  placeholder="Email" />
                  <div class="mt-2">Ingrese su correo electrónico con el que se registró.</div>
                <div class="invalid-feedback">{error && error.email}</div>
              </div>
            </div>

          </div>
        </div>
        <div class="row">
          <div class="col-md-6 col-lg-6">
            <p class="text-center">
              <button
                id="cancel-btn"
                class="btn btn-dark btn-block rounded-0 shadow-none
                justify-content-center"
                type="submit"
                on:click={() => navigateTo('/login')}>
                Volver
              </button>
            </p>
          </div>
          <div class="col-md-6 col-lg-6">
            <p class="text-center">
              <button
                id="submit-btn"
                class="btn btn-primary btn-block rounded-0 shadow-none
                justify-content-center"
                on:click={recovery}
                type="button">
                {button_text_send}
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
